module.exports = __webpack_public_path__ + "static/media/february_afternoon_small.121c610d.jpg";